import { plural, t } from '@lingui/core/macro'

export const getPlural = (numSelectedRows: number, rows: string) =>
  plural(numSelectedRows, {
    one: `Row ${rows} selected`,
    other: `Rows ${rows} selected`,
  })

export const getTooltip = (
  numSelectedRows: number,
  firstRowSelected: number,
  lastRowSelected: number,
  chunksOfSelectedRows: number[][],
) => {
  if (numSelectedRows === 0) {
    return t`Select rows to edit`
  }

  if (chunksOfSelectedRows.length === 1) {
    const rows =
      numSelectedRows > 1 ? `${firstRowSelected}-${lastRowSelected}` : `${firstRowSelected}`

    return getPlural(numSelectedRows, rows)
  }

  const rows = chunksOfSelectedRows
    .map(chunk => (chunk.length === 1 ? `${chunk[0]}` : `${chunk[0]}-${chunk[chunk.length - 1]}`))
    .join(', ')

  return getPlural(numSelectedRows, rows)
}
